import React, { useState } from 'react';

const DiscountBanner = ({ onClose }) => {
    const [isVisible, setIsVisible] = useState(true);

    const handleClose = () => {
        setIsVisible(false);
        if (onClose) onClose();
    };

    if (!isVisible) return null;

    return (
        <div className="bg-blue-600 text-white py-2 overflow-hidden relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <button
                    onClick={handleClose}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white font-bold text-lg z-20"
                    aria-label="Close banner"
                >
                    ×
                </button>
                <div className="flex justify-center items-center overflow-hidden text-center">
                    <span className="text-lg sm:text-xl font-medium">
                        🎉🎉🎉 40% OFF with code <span className="font-bold text-yellow-200">MAP40</span>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default DiscountBanner;